import * as React from 'preact/compat'
import { findDOMNode, unmountComponentAtNode } from 'preact/compat'
import {
    disableScroll,
    disableTabIndex,
    enableScroll,
    enableTabIndex,
    loadStylesheet,
    sgVersion,
    wait,
} from '../common/helpers'
import styles from '../../css/live-comments.pcss.json'
import headerStyles from '../../css/header.pcss.json'
import Loading from '../components/Loading'

// noinspection JSUnusedGlobalSymbols
export default (elements: NodeListOf<HTMLElement>) => {
    let panel: HTMLDivElement;

    const createPanel = async () => {
        const template = document.querySelector<HTMLTemplateElement>('template#live-comments')
        const clone = template.content.cloneNode(true) as HTMLDivElement
        panel = clone.querySelector<HTMLDivElement>(`.${styles['live-comments']}`)
        panel.querySelector(`.${styles['live-comments__header__close']}`).addEventListener('click', () => {
            window.dispatchEvent(new Event('close-all-menus'))
        })
        disableTabIndex(panel)
        document.body.append(clone)
    }

    const btn = document.querySelector(`.${headerStyles['header__live']}`)

    const closePanel = async () => {
        if (!panel) {
            return
        }
        btn.classList.remove(headerStyles['header__live--active'])
        panel.classList.remove(styles['live-comments--in'])
        disableTabIndex(panel)
        if (window.matchMedia('(max-width: 560px)').matches) {
            enableScroll()
        }
        await wait(300)
        if (panel) {
            const domNode = panel.querySelector(`.${styles['live-comments__scrollable-container']}`)
            if (domNode) {
                const reactNode = findDOMNode(domNode)
                unmountComponentAtNode(reactNode)
            }
            panel.remove()
        }
        panel = undefined
    }

    window.addEventListener('close-all-menus', closePanel)

    const outsideClick = async (ev: MouseEvent) => {
        const target = ev.target as HTMLDivElement
        if (target.closest('[data-live-comments]')
            || target.hasAttribute('data-live-comments')
            || target.closest(`.${styles['live-comments']}`)
            || target.classList.contains(styles['live-comments'])
        ) {
            return
        }
        await closePanel();
    }

    const showPanel = async (ev: MouseEvent) => {
        ev.stopImmediatePropagation()
        ev.preventDefault()
        window.dispatchEvent(new Event('close-all-menus'))
        if (window.matchMedia('(max-width: 560px)').matches) {
            disableScroll()
        }
        await createPanel()
        await wait(10)
        if (!panel) {
            return
        }
        btn.classList.add(headerStyles['header__live--active'])
        panel.classList.add(styles['live-comments--in'])
        enableTabIndex(panel)
        window.addEventListener('click', outsideClick)
        React.render(<Loading className={styles['live-comments__loading']} />, panel.querySelector(`.${styles['live-comments__scrollable-container']}`))
        await attachReact()
    }

    const attachReact = async () => {
        const { default: LiveComments } = await import(`/dist/js/components/comments/LiveComments.js?${sgVersion()}`)
        loadStylesheet('live-comments')
        const reactNode = findDOMNode(panel.querySelector(`.${styles['live-comments__scrollable-container']}`))
        unmountComponentAtNode(reactNode)
        React.render(<LiveComments close={closePanel} />, panel.querySelector(`.${styles['live-comments__scrollable-container']}`))
    }

    const togglePanel = async (ev: MouseEvent) => {
        if (btn.classList.contains(headerStyles['header__live--active'])) {
            await closePanel()
            return
        }
        await showPanel(ev)
    }

    elements.forEach(element => {
        element.addEventListener('click', togglePanel)
    })
}
